<template>
  <DxDataGrid
    :data-source="localData.bank_data"
    :showBorders="true"
    ref="partnerBankGrid"
    :element-attr="gridAttributes"
    key-expr="uuid"
  >
    <DxColumn
      dataField="name"
      :caption="$t('stock_management.partners.bank.name')"
    >
      <DxRequiredRule :message="$t('validation.field_is_required')" />
    </DxColumn>
    <DxColumn
      dataField="location_name"
      :caption="$t('stock_management.partners.bank.location_name')"
    >
    </DxColumn>
    <DxColumn
      dataField="iban"
      :caption="$t('common.iban')"
    >
      <!-- Custom rule to validate email format if not empty -->
      <DxCustomRule
        :validation-callback="isValidIbanNumber"
        :message="$t('validation.invalid_iban')"
      />
      <DxRequiredRule :message="$t('validation.field_is_required')" />
    </DxColumn>
    <DxEditing
      mode="form"
      :allowUpdating="true"
      :allowAdding="true"
      :allowDeleting="true"
      :use-icons="true"
    >
      <DxTexts
        :confirm-delete-message="
          $t('common.confirm_delete', {
            title: this.$t(
              'stock_management.partners.edit_groups.banking_data'
            ),
          })
        "
        :confirm-delete-title="$t('common.confirm_delete_title')"
        :save-row-changes="$t('common.save')"
        :cancel-row-changes="$t('common.close')"
        :addRow="$t('common.add_new')"
        :editRow="$t('common.edit')"
        :deleteRow="$t('common.delete')"
      />
    </DxEditing>
    <DxHeaderFilter :visible="false" />
    <DxFilterRow
      :visible="false"
      :showOperationChooser="true"
      apply-filter="auto"
    />
    <DxSelection mode="single" />
  </DxDataGrid>
</template>

<script>
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxTexts,
  DxRequiredRule,
  DxCustomRule,
} from "devextreme-vue/data-grid";
import {
  isValidIBAN,
} from '~/helpers/common';

export default {
  name: "PartnerBankingData",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxTexts,
    DxRequiredRule,
    DxCustomRule,
  },
  data() {
    return {
      gridAttributes: {
        class: "partner-bank-grid",
      },
      localData: { ...this.data }, // Create a local copy of data
    };
  },
  computed: {},
  methods: {
    validate() {
      return true;
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        console.log("updateData step 3 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
    isValidIbanNumber(e) {
      return isValidIBAN(e.value);
    },
  },
  mounted() {},
  watch: {
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-partner-data", newData, 3); // Emit updated data to parent
      },
    },
  },
};
</script>
